(function () {
    function ShowTimeFormatter() {
        return function (showing) {
            var start = showing.StartTime;
            //var v = moment(start).tz('America/New_York').format('h:mm A');
            var v = moment(start, "YYYY-MM-DDTHH:mm:ss").format('h:mm A');
            /**
                console.log('-----testing times------');
                console.log('1',  moment(start, "YYYY-MM-DDTHH:mm:ss").tz('America/New_York').format('MMMM Do @ h:mm a'));
                console.log('2',  moment(start, "YYYY-MM-DDTHH:mm:ssZ").tz('America/New_York').format('MMMM Do @ h:mm a'));
                console.log('3',  moment.utc(start, "YYYY-MM-DDTHH:mm:ssZ").tz('America/New_York').format('MMMM Do @ h:mm a'));
                console.log('4',  moment.utc(start, "YYYY-MM-DDTHH:mm:ssZ").tz('America/New_York').format('MMMM Do @ h:mm a'));
                console.log('5',  moment(start, "YYYY-MM-DDTHH:mm:ss").format('MMMM Do @ h:mm a'));
                console.log('6',  moment(start, "YYYY-MM-DDTHH:mm:ssZ").format('MMMM Do @ h:mm a'));
                console.log('7',  moment.utc(start, "YYYY-MM-DDTHH:mm:ssZ").format('MMMM Do @ h:mm a'));
                console.log('8',  moment.utc(start, "YYYY-MM-DDTHH:mm:ssZ").format('MMMM Do @ h:mm a'));
                console.log('-----------');
                console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
            **/
            //console.log(showing, start, v);
            return v;
        };
    }
    ShowTimeFormatter.$inject = [];
    angular
        .module("cstudioApp.filters")
        .filter("ShowTimeFormatter", ShowTimeFormatter);
})();